import { Box, Button, Divider, Typography } from "@mui/material";
import useQuery from "../../../../../shared/components/hooks/useQuery";
import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import html2pdf from "html2pdf.js";
import dayjs from "dayjs";
import { toWords } from "number-to-words";
import { RiceBowl } from "@mui/icons-material";

const PaymentReceipt = () => {
  const navigate = useNavigate();
  const contentRef = useRef<HTMLDivElement>(null);
  const { transactionID } = useParams();

  const { loading, data, error } = useQuery(`/transactions/${transactionID}`);
  const transaction = (data as any)?.data || null;

  const handleDownloadPDF = () => {
    if (contentRef.current) {
      const options = {
        margin: 0.5,
        filename: "payment-receipt.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };
      html2pdf().set(options).from(contentRef.current).save();
    }
  };

  if (!transaction) return <div>No transaction data available.</div>;

  const {
    paymentGatewayTransactionID,
    amount,
    paymentDate,
    studentClass,
    feeTerm,
  } = transaction;

  const receiptNumber = transaction?.payment?.receiptNumber || "N/A";
  const studentName = studentClass?.student?.name || "N/A";
  const adminNo = studentClass?.student?.admissionNumber || "N/A";
  const className = studentClass?.class?.name || "N/A";
  const rollNumber = studentClass?.rollNumber || "N/A";
  const division = studentClass?.division || "N/A";
  const term = feeTerm?.name || "N/A";
  const formattedDate = dayjs(paymentDate).format("DD-MM-YYYY");

  const amountToWords = (amt: number): string => {
    return `${toWords(amt).replace(/\b\w/g, (l) => l.toUpperCase())} Only`;
  };

  const renderReceipt = () => (
    <Box >
      <Box textAlign="center">
        <Typography variant="h6" fontWeight="bold">
          SN PUBLIC SCHOOL, POOTHOTTA
        </Typography>
        <Typography variant="body2">
          POOTHOTTA P O ERNAKULAM DIST- 682 307
        </Typography>
        <Typography variant="subtitle1" mt={1} fontWeight="bold">
          FEE RECEIPT
        </Typography>
        <Typography variant="body2" mt={0.5} textAlign={"right"}>
          {formattedDate}
        </Typography>
      </Box>

     <Box mt={3} display="flex" flexDirection="column" gap={0.5} >
  {[
    ["Receipt No", receiptNumber],
    ["Name", studentName],
    ["Admin No", adminNo],
    ["Class", `${className} - ${division}`],
    ["Roll No", rollNumber],
    ["Installment", term],
  ].map(([label, value], idx) => (
    <Box key={idx} display="flex" flexDirection="row" >
      <Typography variant="body2" sx={{ minWidth: "110px", fontSize: 14 }} >
        {label}:
      </Typography>
      <Typography variant="body2" >
        {value}
      </Typography>
    </Box>
  ))}
</Box>
<Divider sx={{ my: 1 }} />


   <Box mt={3}>
  <Box display="flex" justifyContent="space-between" >
    <Typography fontWeight="bold" fontSize={14}>
      PARTICULARS
    </Typography>
    <Typography fontWeight="bold" fontSize={14}>
      AMOUNT
    </Typography>
  </Box>
  <Divider sx={{ my: 1 }} />
  <Box>
    {Object.entries(feeTerm?.split || {}).map(([key, val]) =>
      key !== "Total" && key !== "Grand Total" ? (
        <Box
          key={key}
          display="flex"
          justifyContent="space-between"
          fontSize={14}
        >
          <Typography >{key.toUpperCase()}</Typography>
          <Typography>{Number(val).toFixed(2)}</Typography>
        </Box>
      ) : null
    )}
  </Box>
        <Divider sx={{ mt: 1, mb: 1 }} />
        <Box display="flex" justifyContent="space-between" fontWeight="bold">
          <Typography>TOTAL</Typography>
          <Typography>₹{feeTerm?.split?.["Grand Total"] || amount}</Typography>
        </Box>
        <Divider sx={{ mt: 1, mb: 1 }} />
        <Typography variant="body2" mt={1} fontWeight="bold" >
          Rupees {amountToWords(feeTerm?.split?.["Grand Total"] || amount)}
        </Typography>
      </Box>

      <Box mt={5} mb={15} textAlign="right">
        <Typography variant="body2">Cashier / Accountant</Typography>
      </Box>
    </Box>
  );

  return (
    <Box>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button variant="contained" onClick={handleDownloadPDF}>
          Download PDF
        </Button>
      </Box>

      <Box ref={contentRef} sx={{ background: "#fff", p: 3 }}>
        {renderReceipt()}
      </Box>
    </Box>
  );
};

export default PaymentReceipt;
